import React, { useEffect, useState } from 'react';
import { jwtDecode } from 'jwt-decode';
import { Card, Col, Container, Row } from 'react-bootstrap';
import 'font-awesome/css/font-awesome.css';

import { getMsalIdToken } from 'Services/MsalTokenService';
import F2WCustomLogger from 'Services/F2WCustomLogger';

const Unauthorized = (props) => {
  const { errorMessage } = props;
  const [profile, setProfile] = useState({ name: 'User', roles: [] });

  useEffect(() => {
    const loadProfile = async () => {
      try {
        const token = await getMsalIdToken();
        const decoded = jwtDecode(token);
        setProfile(decoded);
      } catch (error) {
        F2WCustomLogger.error('Failed to load profile', error, { view: 'Unauthorized' });
      }
    };
    loadProfile();
  }, []);

  // Function to check error messages and return appropriate error details
  const checkErrorMessages = (errorMessage) => {
    if (errorMessage === '401') {
      return {
        errorMessage: 'Unauthorized, your roles are not correct for this application',
        errorCode: 401,
        errorCurrentValue: profile.roles?.join(', '),
        errorType: 'Roles error',
        errorSolveProblem: 'Please contact your administrator, you don´t have any valid role.',
      };
    }
    return {
      errorMessage: 'Unknown error, we don´t know what happened.',
      errorCurrentValue: 'Unknown, auth value : ' + JSON.stringify(profile),
      errorCode: 500,
      errorType: 'Unknown',
      errorSolveProblem: 'Please contact your administrator, you don´t have any valid role.',
    };
  };

  const preCheckModel = checkErrorMessages(errorMessage);

  // Set the document title on component mount
  useEffect(() => {
    document.title = 'F2w - Unauthorized';
  }, []);

  return (
    <React.Fragment>
      <Container fluid>
        <Card style={{ margin: '5% 0', padding: '2%' }}>
          <Row style={{ justifyContent: 'center', textAlign: 'center', padding: '5% 0' }}>
            <Col>
              <i className="fa fa-hand-spock-o fa-5x">{preCheckModel.errorCode}</i>
            </Col>
          </Row>
          <Row style={{ justifyContent: 'center', textAlign: 'center' }}>
            <Col>
              <h1>Wait a second {profile.name}! ... something seems strange to us</h1>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col lg={{ span: 6, offset: 4 }}>
              <h3>{preCheckModel.errorType}</h3>
              <br />
              <p>
                <strong>Problem :</strong> {preCheckModel.errorMessage}
              </p>
              <p>
                <strong>Current value :</strong> {preCheckModel.errorCurrentValue}
              </p>
              <p>
                <strong>Situation :</strong> {preCheckModel.errorSolveProblem}
              </p>
            </Col>
          </Row>
        </Card>
      </Container>
    </React.Fragment>
  );
};

export default Unauthorized;
